// extracted by mini-css-extract-plugin
module.exports = {"mainText":"MainText--mainText--3f1gC"};